import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListMembershipEventTriggerMatchResultExplanation = ({
  matchResult,
  associatedList
}) => {
  /*
  VALID,
  INVALID_LIST_ID,
  INVALID_CHANGE_STATUS,
  */
  const explanationCopy = (() => {
    switch (matchResult) {
      case 'VALID':
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.VALID"
        });
      case 'INVALID_LIST_ID':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.INVALID_LIST_ID"
        });
      case 'INVALID_CHANGE_STATUS':
        {
          // In general there can be two `listType`s here, but getting an `INVALID_CHANGE_STATUS` match result implies that one of them wasn't valid.
          // So we know for sure there's only one entry in `listTypes` within this case
          if (associatedList.listTypes[0] === 'ADDED_TO_LIST_TRIGGER') {
            return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.INVALID_CHANGE_STATUS.ADDED_TO_LIST_TRIGGER"
            });
          }
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.INVALID_CHANGE_STATUS.REMOVED_FROM_LIST_TRIGGER"
          });
        }
      case 'INVALID_BULK_OBJECT_SEG_SOURCE':
        {
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.INVALID_CHANGE_STATUS.INVALID_BULK_OBJECT_SEG_SOURCE"
          });
        }
      case 'INVALID_OBJECT_SEG_SOURCE':
        {
          return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.description.failed.matchResult.INVALID_CHANGE_STATUS.INVALID_OBJECT_SEG_SOURCE"
          });
        }
      default:
        {
          Raven.captureMessage('Unexpected ListMembershipChangeMatchResult', {
            extra: {
              matchResult
            }
          });
          return null;
        }
    }
  })();
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "list-match-explanation",
    children: [matchResult === 'VALID' ? /*#__PURE__*/_jsx(SuccessIcon, {
      color: "do-not-use-oz",
      alignWithText: true
    }) : /*#__PURE__*/_jsx(RemoveIcon, {
      color: "do-not-use-candy-apple",
      alignWithText: true
    }), explanationCopy]
  });
};
export default ListMembershipEventTriggerMatchResultExplanation;